import { type AutomaticMessageTemplate } from '@/types/messageTemplates';

import createRestClient from '../restClient';

const restClient = createRestClient();

const getAutomaticMessageTemplates: () => Promise<AutomaticMessageTemplate[]> = () =>
  restClient.get('team/automatic-message-templates');

const getAutomaticMessageTemplate = (id: string) =>
  restClient.get(`team/automatic-message-template?templateId=${id}`);

const getMessageTemplateTriggers = (context: string) =>
  restClient.get(`enum/message-template/triggers${context != null ? `?context=${context}` : ''}`);

const getMessageTemplateIdentifiers = (context: string) =>
  restClient.get(
    `enum/message-template/identifiers${context != null ? `?context=${context}` : ''}`,
  );

const createAutomaticMessageTemplate = (data: any) =>
  restClient.post('team/automatic-message-template', data);

const updateAutomaticMessageTemplate = (data: any) =>
  restClient.put('team/automatic-message-template', data);

export default {
  createAutomaticMessageTemplate,
  getAutomaticMessageTemplate,
  getAutomaticMessageTemplates,
  getMessageTemplateIdentifiers,
  getMessageTemplateTriggers,
  updateAutomaticMessageTemplate,
};
